<template>
  <section class="section beforeAfter" :class="{open: show}">
    <transition name="fade">
      <div class="leftBackdrop" v-if="show"
        v-on:click="close"></div>
    </transition>
    <div class="rightContent">
      <div class="tree"></div>
      <div class="rightContentIn">
        <div class="header">
          <div class="backBtn" v-on:click="close"></div>
          <h4>Before After</h4>
        </div>
        <div class="contentSc">
          <div class="menuCnt">
            <div class="menuItem loading" v-if="loading">
              <div class="loadingPrice"></div>
              <h4>Foto Before After</h4>
              <p>Mohon tunggu sedang membuat gambar untuk Before After kamu, ini mungkin
                memakan waktu beberapa saat.</p>
            </div>
            <div class="menuItem report" v-else>
              <img :src="imgUri" class="imgReport">
              <h4>Bagikan melalui</h4>
              <p>Jangan lupa tambahkan hashtag
                <span>#BodyKeyChallenge2023</span> pada post
                Instagram atau Twitter kamu.</p>
              <div class="selectorCnt">
                <a :href="`https://www.facebook.com/sharer/sharer.php?u=${shareEncoded}`"
                  target="_blank" class="selectorItem">
                  <img src="../assets/i-facebook-2.png">
                  <h4>Post</h4>
                </a>
                <a :href="`https://twitter.com/intent/tweet?url=${shareEncoded}&text=${escapedTitle}&related=Amway,Boydkey,Nutrilite,BkChallenges`"
                  target="_blank" class="selectorItem">
                  <img src="../assets/i-twitter-2.png">
                  <h4>Tweet</h4>
                </a>
                <a :href="`https://api.whatsapp.com/send/?phone&text=${waText}&app_absent=0`"
                  target="_blank" class="selectorItem">
                  <img src="../assets/i-wa.png">
                  <h4>Send</h4>
                </a>
                <div class="selectorItem" v-on:click="openIg">
                  <img src="../assets/i-instagram.png">
                  <h4>Instagram</h4>
                </div>
                <a :href="`mailto:?subject=${escapedTitleOnly}&body=${emailBody}`"
                  target="_blank" class="selectorItem">
                  <img src="../assets/envelope-2.png">
                  <h4>Email</h4>
                </a>
              </div>
              <div class="shareLink" v-if="1>2">
                {{shareUriDisplay}}
                <div class="copy" v-on:click="copyToClp(shareUriDisplay)">SALIN</div>
              </div>
              <div class="downloadCnt">
                <a :href="imgUri" class="download" download
                  target="_blank">Download Gambar</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Snackbar ref="snackbar"/>
    <IgDialog ref="igDialog"/>
    <Confirmation ref="confirmDialog"/>
    <Testimoni ref="testimoni"/>
  </section>
</template>

<script>
import Snackbar from '@/components/Snackbar.vue';
import IgDialog from '@/components/IgDialog.vue';
import Confirmation from '@/components/Confirmation.vue';
import Testimoni from '@/components/Testimoni.vue';

export default {
  name: 'home',
  components: {
    Snackbar,
    IgDialog,
    Confirmation,
    Testimoni,
  },
  data() {
    return {
      show: false,
      point: 6000,
      loading: true,
      history: [],
      imgUri: '',
      shareUriDisplay: '',
      escapedTitle: escape('Saya telah menyelesaikan #BodyKeyChallenge2023 bersama Nutrilite'),
      escapedTitleOnly: escape('Saya Telah Menyelesaikan #BodyKeyChallenge2023 bersama Nutrilite'),
      waText: '',
      shareEncoded: '',
    };
  },
  methods: {
    doNothing() {},
    open() {
      this.show = true;
      this.loading = true;
      this.getData();
    },
    close() { this.show = false; },
    copyToClp(txt2copy) {
      const m = document;
      const txt = m.createTextNode(txt2copy);
      const w = window;
      const b = m.body;
      b.appendChild(txt);
      if (b.createTextRange) {
        const d = b.createTextRange();
        d.moveToElementText(txt);
        d.select();
        m.execCommand('copy');
      } else {
        const d = m.createRange();
        const g = w.getSelection;
        d.selectNodeContents(txt);
        g().removeAllRanges();
        g().addRange(d);
        m.execCommand('copy');
        g().removeAllRanges();
      }
      txt.remove();
      this.$refs.snackbar.open({ content: 'Link copied to clipboard.' });
    },
    getData() {
      this.$http.get(this.$config.uri('user/beforeafter')).then((r) => {
        if (r.data.status === 207 && r.data.message === 'no_testimoni') {
          this.$refs.confirmDialog.open({
            title: 'Isi Testimoni',
            desc: 'Kamu harus mengisi testimoni terlebih dahulu untuk membuat foto Before After',
            action: 'Isi Testimoni',
          }, (b) => {
            if (!b) {
              this.close(false);
              return;
            }
            this.$refs.testimoni.open(null, (b2) => {
              if (!b2) {
                this.close(false);
                return;
              }
              this.getData();
            });
          });
          return;
        }
        this.shareUriDisplay = `${this.$config.cdnUri}beforeafter/s6/${r.data.uuid}`;
        this.shareEncoded = escape(this.shareUriDisplay);
        this.waText = `${this.escapedTitle}${escape('. Lihat foto before after saya di ')}${this.shareEncoded}`;
        this.emailBody = escape(`Hi!\n\n${this.escapedTitle}. Lihat foto before after saya di ${this.shareEncoded}`);
        this.imgUri = (r.data.status === 200) ? r.data.uri : '';
        this.loading = false;
      });
    },
    openIg() {
      this.$refs.igDialog.open();
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.section.beforeAfter{
  position: fixed;
  right: 0; top: 0; bottom: 0;
  left: auto;
  padding: 0;
  z-index: 9997;
  .rightContent{
    position: fixed;
    right: 0; top: 0; bottom: 0;
    background-color: #e6e1c1;

    background-color: #b7e4c9;
    background-image: linear-gradient(#fff 0, #e2fcec 50%, #fff);

    padding: 0 0 40px;
    box-sizing: border-box;
    width: 480px;
    z-index: 3;
    right: -480px;
    transition: all .45s ease;
    @media (max-width: 768px) {
      top: 60px;
    }
    @media (max-width: 680px) {
      width: 96%; right: -96%;
    }
    .tree{
      position: absolute;
      left: 0; right: -10px; bottom: 0; top: 0;
      background-image: url(../assets/high-five.png);
      background-size: auto 160px;
      background-position: right bottom;
      background-repeat: no-repeat;
    }
  }
  .leftBackdrop{
    position: fixed;
    left: 0; right: 0; top: 0; bottom: 0;
    background-color: #000;
    background-color: rgba(0,0,0,.7);
    z-index: 1;
    transition: all .3s ease;
  }
  &.open{
    .rightContent{
      right: 0;
    }
  }
  .header{
    position: relative;
    padding: 5px 20px;
    z-index: 7;
    box-shadow: 0 0 4px rgba(0, 0, 0, .2);
    backdrop-filter: blur(20px);
    .backBtn{
      width: 40px; height: 40px;
      border-radius: 50%;
      background-color: #fff;
      background-image: url(../assets/arrow-next-black.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      transition: all .3s ease;
      cursor: pointer;
      &:hover{
        background-color: #f5f5f5;
      }
    }
    h4{
      font-size: 18px;
      margin: 0;
      color: #444;
      position: absolute;
      left: 80px; top: 13px; right: 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .contentSc{
    position: absolute;
    left: 0; right: 0; top: 0; bottom: 0;
    overflow-y: auto;
    z-index: 5;
    padding: 60px 10px 10px;
  }
  .profilePict{
    width: 94px; height: 94px;
    background-color: #ccc;
    border-radius: 50%;
    margin: 0 auto 16px;
    background-image: url(../assets/bruno-mars.jpg);
    background-position: center;
    background-size: cover;
  }
  .profileInfo{
    text-align: center;
    padding-bottom: 20px;
    h4{
      margin: 0;
      font-size: 20px;
    }
    p{
      margin: 0;
      font-size: 15px;
    }
  }
  .expCnt{
    background-color: rgba(255, 255, 255, .5);
    margin: 0 10px 10px;
    border-radius: 10px;
    padding: 16px 20px 20px;
    position: relative;
    h4{
      margin: 0 0 6px;
      font-size: 16px;
    }
    .expLabel{
      position: absolute;
      right: 20px; top: 18px;
      font-size: 14px;
    }
    .theExp{
      height: 12px;
      background-color: #ccc;
      border-radius: 50px;
      .exp{
        height: 100%;
        max-width: 100%;
        background-color: #8EC642;
        // background-color: #6aa722;
        border-radius: 50px;
      }
    }
    .info{
      font-size: 12px;
      color: #555;
      text-align: right;
      margin: 5px 5px 0;
    }
  }

  .selectorCnt{
    display: flex;
    justify-content: center;
    @media (max-height: 680px) {
      // justify-content: space-between;
    }
    .selectorItem{
      padding: 14px 34px 10px;
      border: #fff 1px solid;
      border-radius: 5px;
      transition: all .2s ease;
      position: relative;
      text-align: center;
      color: #444;
      padding: 14px 10px 10px;
      @media (max-height: 680px) {
        padding: 14px 10px 10px;
      }
      &:hover{
        opacity: 1;
        // border-color: #f5f5f5;
        // box-shadow: 2px 2px 2px rgba(0,0,0,.1);
        cursor: pointer;
        background-color: #f5f5f5;
      }
      h4{
        margin: 0;
        font-size: 14px;
        font-weight: 600;
        color: #006519;
        font-size: 12px;
      }
      img{
        height: 30px;
        margin-bottom: 5px;
      }
    }
  }

  .downloadCnt{
    text-align: center;
  }
  .download{
    background-color: #8EC642;
    color: #fff;
    padding: 10px 20px;
    box-sizing: border-box;
    border-radius: 3px;
    // box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
    display: inline-block;
    text-align: center;
    // font-weight: bold;
    margin-top: 10px;
    padding-left: 48px;
    position: relative;
    &:before{
      position: absolute;
      content: "";
      left: 14px; top: 5px;
      width: 24px; height: 24px;
      background-image: url(../assets/download-o-white.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
  .shareLink{
    margin: 10px 10px 4px;
    background-color: #f5f5f5;
    border: #ccc 1px solid;
    border-radius: 3px;
    color: #222;
    padding: 10px 12px;
    position: relative;
    padding-right: 80px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: normal;
    .copy{
      position: absolute;
      right: 4px; top: 4px;
      font-weight: 600;
      color: #005ab5;
      padding: 6px 10px;
      border-radius: 3px;
      cursor: pointer;
      &:hover{
        background-color: #ddd;
      }
    }
  }

  .menuCnt{
    padding: 10px 0 40px;
    h4{
      margin: 0 20px 6px;
    }
    .divider{
      height: 20px;
    }
    .menuItem{
      padding: 16px 20px;
      font-weight: bold;
      color: #444;
      position: relative;
      background-color: rgba(255, 255, 255, .6);
      background-color: #fff;
      // background-image: linear-gradient(to left, #8EC642, #669922);
      // color: #fff;
      margin: 0 10px 10px;
      border-radius: 5px;
      font-size: 17px;
      min-height: 80px;
      box-sizing: border-box;
      &.report{
        padding: 10px;
        padding-bottom: 30px;
        text-align: center;
        h4{
          margin: 0 0 2px;
        }
        p{
          margin: 0 10px 4px;
          font-size: 14px;
          font-weight: normal;
          span{
            color: #006519;
            font-weight: bold;
          }
        }
      }
      img.imgReport{
        width: 100%;
        margin-bottom: 16px;
      }
      .loadingPrice{
        height: 40px;
        background-color: rgba(255, 255, 255, 0.5);
        background-color: transparent;
        background-image: url(../assets/loading.svg);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 36px auto;
        height: 300px;
      }
      &.loading{
        text-align: center;
        color: #767676;
        padding-bottom: 40px;
        h4{
          margin: 0 0 2px;
          font-size: 20px;
        }
        p{
          margin: 0;
          font-weight: normal;
          font-size: 15px;
        }
      }
      .bcCnt{
        display: flex;
        flex-wrap: wrap;
        padding-top: 8px;
        @media (max-width: 410px) {
          margin-bottom: -10px;
        }
        .bcItem{
          font-size: 13px;
          font-weight: normal;
          width: 32%;
          color: #767676;
          @media (max-width: 410px) {
            width: 50% !important;
            margin-bottom: 10px;
          }
          &.weight{
            width: 26%;
          }
          &.bmi{
            width: 21%;
          }
          span{
            display: block;
            font-weight: bold;
            font-size: 20px;
            color: #444;
          }
        }
      }
      .photoCnt{
        display: flex;
        margin: 0 -5px;
        padding-top: 8px;
        .photoItem{
          width: calc(33.3333% - 10px);
          margin: 0 5px;
          .thePhotoImgCnt{
            position: relative;
            height: 127px;
            overflow: hidden;
            background-color: #eee;
            border-radius: 5px;
            .thePhotoImg{
              cursor: pointer;
              position: absolute;
              max-width: 100%;
              max-height: 100%;
              top: -9999px;
              left: -9999px;
              right: -9999px;
              bottom: -9999px;
              margin: auto;
            }
          }
          .thePhoto{
            border-radius: 5px;
            background-color: #222;
            height: 126px;
            background-position: center;
            background-size: cover;
          }
          h4{
            font-size: 14px;
            margin: 4px 0 0;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
